import React, { useState } from 'react'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CForm,
  CCol,
  CFormInput,
  CButton,
  CFormLabel,
  CSpinner,
} from '@coreui/react-pro'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import * as xlsx from 'xlsx'
import axios from 'axios'
import { businessApiURL } from 'src/business/services'
const AddBulkSubscriber = () => {
  const [items, setItems] = useState()
  const [uploadedFile, setUploadedFile] = useState('')
  const [loading, setLoading] = useState(false)

  const readUploadFile = (e) => {
    e.preventDefault()
    if (e.target.files) {
      const reader = new FileReader()
      reader.onload = (e) => {
        setUploadedFile(e.target.result)
        console.log(e.target.result)
        console.log(e.target.result)
        const data = e.target.result
        const workbook = xlsx.read(data, { type: 'array' })
        const sheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[sheetName]
        const json = xlsx.utils.sheet_to_json(worksheet)
        console.log(json)
        setItems(json)
        document.getElementById('jsonData').innerHTML = JSON.stringify(json)
      }
      reader.readAsArrayBuffer(e.target.files[0])
    }
  }
  const bulkUpload = async () => {
    setLoading(true)
    const token = localStorage.getItem('token')
    axios.post(`${businessApiURL}/api/secure/bc/subscribers/bulk/upload`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: items,
    })
      .then((res) => {
        console.log(res.data)
        setLoading(false)
        toast.success('Bulk Upload Successfully Completed')
      })
      .catch((error) => {
        setLoading(false)
        toast.error('Bulk Upload Failed! Try Again')
      })
  }
  return (
    <>
      {loading ? (
        <CSpinner className={loading ? `block p-4 m-4` : `hidden`} />
      ) : (
        <div>
          <div className="p-4">
            <h1 className="text-textHeading dark:text-white font-bold px-3 py-2">
              Add Subscribers in Bulk
            </h1>
            <CCard className="mt-3 border-primary bg-cardLight dark:bg-cardDark">
              <CCardBody>
                <CForm onSubmit={bulkUpload} className="row g-3 needs-validation" noValidate>
                  <CCol md={6}>
                    <CFormLabel className="dark:text-white pl-1 py-3">
                      Add Subscribers via Excel Sheet
                    </CFormLabel>
                    <a
                      href="Add_Bulk_Subscribers_Aumhum.xlsx"
                      className="btn btn-ghost-info font-black"
                      download={true}
                    >
                      Download Sample
                    </a>
                    <CFormInput
                      type="file"
                      name="upload"
                      id="upload"
                      onChange={readUploadFile}
                      accept=".xls,.xlsx"
                      valid={items?.length !== 0 && items !== undefined}
                      invalid={items?.length === 0 && items === undefined}
                      required
                    />
                  </CCol>
                  <CCol xs={12}>
                    <CButton type="submit">Upload Data</CButton>
                  </CCol>
                </CForm>
                <pre id="jsonData" className="text-secondary"></pre>
              </CCardBody>
            </CCard>
          </div>
        </div>
      )}
    </>
  )
}

export default AddBulkSubscriber
